export default __webpack_public_path__ + "f268d6cd1eb9ea7f82b479a4b5f676a4.png";